import { JSX } from 'react';

export type PictureProps = JSX.IntrinsicElements['picture'] & {
  sources: Array<JSX.IntrinsicElements['source']>;
  img: JSX.IntrinsicElements['img'];
};

export const Picture = ({ sources, img, ...props }: PictureProps) => {
  return (
    <picture {...props}>
      {sources.map((source, index) => (
        <source key={index} {...source} />
      ))}
      {/* oxlint-disable-next-line jsx-a11y/alt-text */}
      <img {...img} />
    </picture>
  );
};
